@if (networkAvailable) {
  @if (filteredProducts?.length) {
    <ngx-dynamic-hooks
      class="block text-dark text-center mb-8 lg:mb-14"
      [content]="hasEligibleProduct ? slice.product_when_eligible : slice.other_products_available_when_ineligible"
      [options]="{ updateOnPushOnly: true }"
    ></ngx-dynamic-hooks>
    @if (slice.type_of_page_shown_on === 'home page') {
      @if (filteredTabs.length > 1) {
        <div
          class="bg-[--color-gray-5] border-[1px] border-[--color-gray-4] flex rounded-2xl justify-center max-w-xl mx-6 md:mx-auto mb-4 h-20"
          data-testid="products-tab"
        >
          @if ({ activeFilterTabId: (activeFilterTab$ | async).id }; as $) {
            @for (filter of filteredTabs; track filter; let first = $first; let last = $last) {
              <button
                class="font-bold flex flex-1 flex-col lg:flex-row justify-center items-center text-sm lg:text-lg"
                [ngClass]="{
                  'text-[var(--color-primary)] shadow-[0_2px_24px_rgba(0,0,0,0.1)] bg-white':
                    $.activeFilterTabId === filter.id,
                  'text-gray-2': $.activeFilterTabId !== filter.id,
                  'rounded-l-2xl': first,
                  'rounded-r-2xl': last,
                  'border-r-[1px] border-[--color-gray-4]': !last,
                }"
                (click)="onTabClick(filter)"
              >
                <lib-svg
                  class="normal p-1.5"
                  [svg]="slice.tabConfig[filter.id + '_tab_icon'] ?? filter.iconName"
                ></lib-svg>
                <span>
                  {{ slice.tabConfig[filter.id + '_tab_title'] ?? ([filter.id] | translate) }}
                </span>
              </button>
            }
          }
        </div>
      }
    }
    <lib-swiper [index]="initialSlideIndex">
      @for (product of filteredProducts; track product) {
        <lib-product-box
          [productItem]="product"
          [typeOfPageShownOn]="slice.type_of_page_shown_on"
          [showLearnMore]="!hasEligibleProduct"
          *libSwiperItem
        >
        </lib-product-box>
      }
    </lib-swiper>
  }
} @else {
  <p class="text-lg lg:text-2xl text-dark font-bold text-center mb-4">
    {{ ['linecheckNoProducts'] | translate }}
  </p>
}
